// Restaurant Configuration File
// This file contains all customizable parameters for the restaurant

// Define the interface for the restaurant configuration
export interface RestaurantConfig {
  // Theme colors
  theme: {
    primary: string;
    secondary: string;
    accent: string;
    background: string;
    text: string;
    lightText: string;
    success: string;
    error: string;
  };

  // Logo and banner images
  images: {
    logo: string;
    banner: string;
    favicon: string;
  };

  // Restaurant information
  restaurant: {
    name: string;
    description: string;
    minimumOrderValue?: number;
    openingHours: Array<{
      dayOfWeek: number; // 0-6 (Sunday-Saturday)
      timeSlots: Array<{
        open: string; // HH:MM format
        close: string; // HH:MM format
      }>;
    }>;
  };

  // Delivery options
  deliveryOptions: {
    delivery: boolean;
    takeaway: boolean;
    dineIn: boolean;
    takeawayTime?: string;
    deliveryRadiusConfig?: Array<{
      radiusKm: number; // radius in kilometers
      fee: number; // fee for this radius
      estimatedTime: string; // estimated time for this radius
    }>;
  };

  // Geolocation coordinates for the restaurant
  geolocation?: {
    latitude: number;
    longitude: number;
  };

  // SEO and metadata
  seo: {
    title: string;
    description: string;
    keywords: string[];
  };
}

// Export the restaurant configuration
const restaurantConfig: RestaurantConfig = {
  theme: {
    primary: '#e74c3c',
    secondary: '#c0392b',
    accent: '#2ecc71',
    background: '#ffffff',
    text: '#1A202C',
    lightText: '#4A5568',
    success: '#38a169',
    error: '#e53e3e',
  },
  images: {
    logo: 'https://via.placeholder.com/150x150?text=LOGO',
    banner: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    favicon: '/favicon.ico',
  },
  restaurant: {
    name: 'Restaurante Delícia',
    description: 'O melhor sabor da cidade em sua mesa',
    minimumOrderValue: 20.00,
    openingHours: [
      {
        dayOfWeek: 0,
        timeSlots: [{ open: '11:00', close: '22:00' }],
      },
    ],
  },
  deliveryOptions: {
    delivery: true,
    takeaway: true,
    dineIn: true,
    takeawayTime: '15-25 min',
    deliveryRadiusConfig: [
      { radiusKm: 2, fee: 5.00, estimatedTime: '15-25 min' },
    ]
  },

  // Geolocation coordinates for the restaurant
  geolocation: {
    latitude: -22.4666,
    longitude: -44.4477
  },

  seo: {
    title: 'Restaurante Delícia - Cardápio Digital',
    description: 'Conheça o cardápio do Restaurante Delícia. Pratos deliciosos, entrega rápida e atendimento de qualidade.',
    keywords: ['restaurante', 'comida', 'delivery', 'cardápio digital', 'São Paulo']
  }
};

export default restaurantConfig;
